module.exports = __webpack_public_path__ + "media/images/svg/blog-c73e1a9fe28b277dc3d8b285041a40c8.svg";